<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" class="btn btn-outline-success" (click)="onGuardarRechazoParcial()"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">        
        <h4 style="display:inline"> Rechazo Parcial {{CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitud | IconoTipoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{EstadoSolicitudDescripcion}}" />
                <img *ngIf="IdEstadoChedPp" class="estado-icono-big" container="body" src="{{IdEstadoChedPp | IconoEstadoChedPP}}" ngbTooltip="{{IdEstadoChedPpDescripcion}}" />
                <img *ngIf="IdResultadoEnvioMuestrasLaboratorio" class="estado-icono-big" container="body" src="{{IdResultadoEnvioMuestrasLaboratorio | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{DescripcionIdResultadoEnvioMuestrasLaboratorio}}" />
                <img class="predua-icono-big" container="body" ngbTooltip="{{EsPredua | preduaNoPredua}}" src="{{EsPredua | IconoPreduaSolicitud}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <div class="row">
                    <!--GRID PRODUCTOS-->
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> <strong>Lista de productos</strong>
                            </div>

                            <div class="card-body-grid">

                                <p-table #tableSearch autoLayout="true" [value]="solicitudProductos?.TProductoSolicitudCollection"
                                         [columns]="colsProds" sortField="CodigoTaric" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(solicitudProductos?.TProductoSolicitudCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                
                                                <span *ngIf="(col.field!=='Link' && col.field!=='Grupo' && col.field!=='IdFormaDescripcion' && col.field !== 'Peso' && col.field !== 'Volumen')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <span *ngIf="(col.field === 'Grupo' || col.field === 'IdFormaDescripcion')" ngbTooltip="{{ rowData[col.field] }}">
                                                    {{rowData[col.field] | truncate:[25, '...'] }}
                                                </span>

                                                <span *ngIf="(col.field === 'Peso' || col.field === 'Volumen')">
                                                    {{rowData[col.field] | number:'1.3-3':'es'}}
                                                </span>

                                                <div *ngIf="col.field==='Link'" class="btn-group">

                                                    <div *ngIf="rowData['Aceptado'] == null">
                                                        <button (click)="marcarProductoAceptado(rowData,true)" type="button" title="Marcar como Aceptado o Rechazado"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-circle-thin"></span>

                                                        </button>
                                                    </div>

                                                    <div *ngIf="rowData['Aceptado'] == true">
                                                        <button (click)="marcarProductoAceptado(rowData,false)" type="button" title="Marcado como Aceptado. Pinche otra vez si quiere cambiar la decisión"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-check"></span>

                                                        </button>
                                                    </div>

                                                    <div *ngIf="rowData['Aceptado'] == false">
                                                        <button (click)="marcarProductoAceptado(rowData,true)" type="button" title="Marcado como Rechazado. Pinche otra vez si quiere cambiar la decisión"
                                                                class="btn btn-sm btn-reject">
                                                            <span class="fa fa-ban"></span>

                                                        </button>
                                                    </div>

                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                                <div *ngIf="solicitudProductos?.TProductoSolicitudCollection?.length === 0" class="empty-grid">
                                    No hay productos asociados a la solicitud
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    
                    <!--GRID EMBALAJES-->
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> <strong>Lista de embalajes</strong>
                            </div>

                            <div class="card-body-grid">

                                <p-table #tableSearch autoLayout="true" [value]="solicitudProductos?.TwEmbalajesCollection"
                                         [columns]="colsEmbalajes" sortField="CodigoTaric" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(solicitudProductos?.TwEmbalajesCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='IdTaricEmbalajeDescripcion' && col.field!=='IdUnidadEmbalajeDescripcion')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <span *ngIf="(col.field === 'IdTaricEmbalajeDescripcion' || col.field === 'IdUnidadEmbalajeDescripcion')" ngbTooltip="{{ rowData[col.field] }}">
                                                    {{rowData[col.field] | truncate:[100, '...'] }}
                                                </span>

                                                <div *ngIf="col.field==='Link'" class="btn-group">

                                                    <div *ngIf="rowData['Aceptado'] == null">
                                                        <button (click)="marcarEmbalajeAceptado(rowData,true)" type="button" title="Marcar como Aceptado o Rechazado"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-circle-thin"></span>

                                                        </button>
                                                    </div>

                                                    <div *ngIf="rowData['Aceptado'] == true">
                                                        <button (click)="marcarEmbalajeAceptado(rowData,false)" type="button" title="Marcado como Aceptado. Pinche otra vez si quiere cambiar la decisión"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-check"></span>

                                                        </button>
                                                    </div>

                                                    <div *ngIf="rowData['Aceptado'] == false">
                                                        <button (click)="marcarEmbalajeAceptado(rowData,true)" type="button" title="Marcado como Rechazado. Pinche otra vez si quiere cambiar la decisión"
                                                                class="btn btn-sm btn-reject">
                                                            <span class="fa fa-ban"></span>

                                                        </button>
                                                    </div>

                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                                <div *ngIf="solicitudProductos?.TwEmbalajesCollection?.length === 0" class="empty-grid">
                                    No hay embalajes asociados a la solicitud
                                </div>
                            </div>
                            <!--CONTADOR DE BULTOS-->
                            <div *ngIf="solicitudProductos?.TwEmbalajesCollection?.length > 0" class="card-body-detalle-bot125">
                                <div class="col-md-2">
                                    <label class="col-form-label" for="inpTotalBultos">Nº Total de Bultos</label>
                                    <input readonly name="TotalBultos" title="" class="form-control" id="inpTotalBultos" type="text" value="{{ numeroBultosTotales }}">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</form>
